import { makeSceneDoc } from '../kit.js';

/**
 * 城外公路：正式的大道，路面铺装过，跑车不颠。
 * 南端就是城门口，路上停着卖零件的、卖水果的，还有一块「前方城墙五百步」的路碑。
 */
export const highwayDoc = makeSceneDoc({
  id: 'highway',
  name: '城外公路',
  region: 'road',
  tier: 1,
  node: 'highway',
  desc: '路面平展，能跑车。往南看，能看见城墙的影子。',
  w: 44, h: 26,
  fill: ',',
  spawn: { gx: 22, gy: 2 },
  draw(b, rng) {
    b.rect(0, 0, 44, 26, ',');
    b.rect(12, 0, 20, 26, '=');                    // 路面（街砖充当铺装）
    for (let y = 1; y < 26; y += 2) b.set(22, y, '/'); // 车道虚线
    b.rect(0, 0, 12, 26, ',');
    b.rect(32, 0, 12, 26, ',');
    b.rect(1, 4, 9, 6, 'f');
    b.rect(34, 12, 9, 8, 'f');
    b.scatter(',', 30, { rng, area: [0, 0, 11, 26] });
    b.scatter(',', 30, { rng, area: [33, 0, 11, 26] });
    // 关卡前的一段值房
    b.rect(10, 20, 24, 3, '^');
  },
  props: [
    { type: 'vehicle_parts_vendor', gx: 14, gy: 6 },
    { type: 'flat_fruit_vendor', gx: 30, gy: 14 },
    { type: 'road_sign', gx: 33, gy: 4 },
    { type: 'milestone', gx: 11, gy: 18 },
    { type: 'tire_pile', gx: 15, gy: 12 },
    { type: 'broken_cart', gx: 28, gy: 8 },
    { type: 'junk_pile', gx: 17, gy: 19 },
    { type: 'tree', gx: 6, gy: 14 },
    { type: 'tree', gx: 38, gy: 6 },
  ],
  portals: [
    { to: 'country_road', gx: 22, gy: 1, spawn: [20, 23], label: '回土路' },
    { to: 'gate', gx: 22, gy: 24, spawn: [22, 21], label: '城门口' },
  ],
});

export default highwayDoc;
